/* eslint-disable import/no-anonymous-default-export */
import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";
import environment from "environments/environment";

export default (input, callback) => {
  const mutation = graphql`
    mutation importCsvMutation($input: importCsvInput!) {
      importCsv(input: $input) {
        importLog {
          id
          createdAt
          fileName
          importedAt
          importedBy
          totalRows
          successCount
          failureCount
          contactsBeforeLoad
          contactsAfterLoad
        }
      }
    }
  `;

  const variables = {
    input: input,
  };

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: callback,
    onError: (err) => console.error("Api Error", err),
  });
};
